import React from 'react'
import ReactDOM from 'react-dom'
import './webflow.css'
import './felsv.webflow.css'
import './felsv2.webflow.css'
import './normalize.css'
import './styles/Fel-inputs.css'
import './styles/responsive.css'
import './text-responsive.css'
import App from './App'
import {BrowserRouter} from 'react-router-dom'
import axios from 'axios'
import {Provider} from 'react-redux'
import {persistor, store} from './store/store'
import {PersistGate} from 'redux-persist/integration/react'
import './i18n/i18n'

axios.defaults.baseURL = process.env.REACT_APP_API || 'http://localhost:3000/api'
axios.defaults.headers.common = {
  Authorization: `Bearer ${localStorage.getItem('authorizationClient')}`,
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
